var _rect, _circle, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrossWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5145_16577",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 37,
    height: 37
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.125,
    width: 36,
    height: 36,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5145_16577)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.375,
    cy: 18.125,
    r: 17.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4357 18.1249L22.6554 14.9052C22.9487 14.6119 22.9487 14.1379 22.6554 13.8447C22.3622 13.5514 21.8882 13.5514 21.5949 13.8447L18.3752 17.0644L15.1554 13.8447C14.8622 13.5514 14.3882 13.5514 14.0949 13.8447C13.8017 14.1379 13.8017 14.6119 14.0949 14.9052L17.3147 18.1249L14.0949 21.3447C13.8017 21.6379 13.8017 22.1119 14.0949 22.4052C14.2412 22.5514 14.4332 22.6249 14.6252 22.6249C14.8172 22.6249 15.0092 22.5514 15.1554 22.4052L18.3752 19.1854L21.5949 22.4052C21.7412 22.5514 21.9332 22.6249 22.1252 22.6249C22.3172 22.6249 22.5092 22.5514 22.6554 22.4052C22.9487 22.1119 22.9487 21.6379 22.6554 21.3447L19.4357 18.1249Z",
    fill: "#333333"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5145_16577",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 10,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4357 18.1249L22.6554 14.9052C22.9487 14.6119 22.9487 14.1379 22.6554 13.8447C22.3622 13.5514 21.8882 13.5514 21.5949 13.8447L18.3752 17.0644L15.1554 13.8447C14.8622 13.5514 14.3882 13.5514 14.0949 13.8447C13.8017 14.1379 13.8017 14.6119 14.0949 14.9052L17.3147 18.1249L14.0949 21.3447C13.8017 21.6379 13.8017 22.1119 14.0949 22.4052C14.2412 22.5514 14.4332 22.6249 14.6252 22.6249C14.8172 22.6249 15.0092 22.5514 15.1554 22.4052L18.3752 19.1854L21.5949 22.4052C21.7412 22.5514 21.9332 22.6249 22.1252 22.6249C22.3172 22.6249 22.5092 22.5514 22.6554 22.4052C22.9487 22.1119 22.9487 21.6379 22.6554 21.3447L19.4357 18.1249Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5145_16577)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossWhite);
export default __webpack_public_path__ + "static/media/cross-white.8c63457bddf9182736303eb44da821e5.svg";
export { ForwardRef as ReactComponent };